<div class="content shadow-component">
    <div [ngClass]="getClass('tog')"></div>
    <span> {{ text }}</span>
    <div [ngClass]="getClass('button')" class="pointer" (click)="close()">
        <i class="fas fa-xmark"></i>
    </div>
</div>
